const isServer = typeof window === "undefined";

export const configuration = isServer
  ? {
      API_URL: process.env.SERVER_API_URI,
    }
  : {
      API_URL: process.env.CLIENT_API_URI,
    };
